import { useState } from "react";

type BannerKind = "castle" | "army" | "profile" | "marches" | "alliance";

interface Props {
  kind: BannerKind;
  title: string;
  subtitle?: string;
}

// Wide painterly header strip at the top of a screen. Loads /icons/banners/{kind}.jpg
// as a covered background; falls back to a gradient if missing.
export function ScreenBanner({ kind, title, subtitle }: Props) {
  const [failed, setFailed] = useState(false);
  return (
    <div className="relative h-16 w-full overflow-hidden">
      {!failed && (
        <img
          src={`/icons/banners/${kind}.jpg`}
          alt=""
          aria-hidden
          onError={() => setFailed(true)}
          className="absolute inset-0 h-full w-full object-cover"
          loading="eager"
        />
      )}
      {/* Dark gradient overlay for text legibility */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.55) 100%)",
        }}
      />
      {/* Text sits over a dark painterly image, so we force white regardless
          of Telegram theme — otherwise on light theme the inherited near-black
          text vanishes into the dark image. */}
      <div className="relative flex h-full items-end px-3 pb-2 text-white">
        <div>
          <div className="text-base font-semibold leading-tight drop-shadow-md">
            {title}
          </div>
          {subtitle && (
            <div className="text-xs text-white/80 drop-shadow">{subtitle}</div>
          )}
        </div>
      </div>
    </div>
  );
}
